module.exports = __webpack_public_path__ + "media/Avo.92efca6c.mp3";